export default __webpack_public_path__ + "static/media/ga.27f86968.svg";